import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Stack, CircularProgress } from "@mui/material";
import ExcellIcon from "../../assets/images/Excell.png";

const DownloadExcel = ({ data, columns, filename }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(filename);

      worksheet.columns = columns.map((col) => ({
        header: col.header,
        key: col.key,
        width: col.width || 20,
      }));

      // Header styling
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
      });

      // Data rows
      data.forEach((item) => {
        const row = worksheet.addRow(item);
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "left" };
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${filename}.xlsx`);
    } catch (error) {
      console.error("Error downloading the Excel file", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center" height={"25px"}>
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <img src={ExcellIcon} alt="excel" style={{ height: 17, width: 17 }} />
      )}
      <button
        disabled={loading}
        style={{
          border: "none",
          background: "#fff",
          fontFamily: '"Open Sans", sans-serif',
          cursor: loading ? "not-allowed" : "pointer",
        }}
        onClick={handleDownload}
      >
        {loading ? "Downloading..." : "Download Excel"}
      </button>
    </Stack>
  );
};

export { DownloadExcel };
